// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28HyT","largestCol":"styles_largestCol__2_UZR","smallestCol":"styles_smallestCol__2syDQ"};